import { render, staticRenderFns } from "./img-picker.vue?vue&type=template&id=08092a98"
import script from "./img-picker.vue?vue&type=script&lang=js"
export * from "./img-picker.vue?vue&type=script&lang=js"
import style0 from "./img-picker.vue?vue&type=style&index=0&id=08092a98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports